import { VocalEffects } from "constants/vocalPresets";

import type { FeatureFlagsState } from "./types";

export const featureFlagsInitialState: FeatureFlagsState = {
	songListPlayNow: false,
	useNativeKeyboard: false,
	isCameraActivated: true,
	isVocalGuideActivated: true,
	vocalEffects: false,
	musicEffects: false,
	isChildSafe: false,
	isIAPWebcamActivated: false,
	selectedEffect: VocalEffects.DEFAULT,
	isTvPromoActivated: true,
	isRouletteActivated: false,
	isBlindTestActivated: false,
	isAirconsoleActivated: false,
	isSuggestedTitleActivated: false,
	publicInteraction: {
		isWaitingSongActivated: false,
		isActivated: false,
		publicSingerName: null,
		publicRoomId: null,
		isPaused: false,
	},
};
